<div class="sidebar-detail">
  <div *ngIf="locationDetail.displayName">
    <a [routerLink]="personLink">{{ locationDetail.displayName }}</a>
    <span *ngIf="locationDetail.isAffiliatedProvider" class="ic-status-affiliated"></span>
    <span *ngIf="locationDetail.isEasyClaim" class="ic-status-easy-claim"></span>
  </div>
  <div *ngIf="locationDetail.practiceName">
    <a [routerLink]="placeLink">{{ locationDetail.practiceName }}</a>
    <span
      *ngIf="locationDetail.isAffiliatedProvider && !locationDetail.displayName"
      class="ic-status-affiliated"></span>
    <span *ngIf="locationDetail.isEasyClaim && !locationDetail.displayName" class="ic-status-easy-claim"></span>
  </div>
  <!-- <div *ngIf="locationDetail.facilityname">{{locationDetail.facilityname}}</div> -->
  <div *ngIf="locationDetail.receptionLocation">
    {{ locationDetail.receptionLocation }}
  </div>
</div>
